@use '../../../../styles/Colors.scss' as Colors;
@use '../../../../styles/Constants.scss' as Constants;

$var-checkbox-size: 16px;

.select-checkbox {
	position: relative;
  
	input[type='checkbox'] {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		
		width: $var-checkbox-size;
		height: $var-checkbox-size;
		border: 2px solid Colors.$col-greyMid;
		background-color: transparent;
		border-radius: 2px;
		cursor: pointer;

		&:focus:not(:checked)
		{
			border-color: Colors.$col-greyMid !important;
			background-color: transparent;
		}

		&:checked {
			background-color: Colors.$col-orange;
			border-color: Colors.$col-orange;
			
			&::after {
				content: '';
				position: absolute;
				left: 5px;
				top: 0px;
				width: 6px;
				height: 12px;

				border-right: 2px solid #fff;
				border-bottom: 2px solid #fff;
				transform: rotate(45deg);
			}
		}
	}
}
